import React from 'react';
import './AdminFooter.css';

export const AdminFooter: React.FC = () => {
  return (
    <footer className="admin-footer">
      <div className="admin-footer__content">
        <p className="admin-footer__text">
          Kenya Friars Admin Panel © {new Date().getFullYear()}. All Rights Reserved.
        </p>
        <p className="admin-footer__text">
          Developed by{' '}
          <a
            href="https://josongtech.com"
            target="_blank"
            rel="noopener noreferrer"
            className="admin-footer__link"
          >
            josongtech developers
          </a>
        </p>
      </div>
    </footer>
  );
};
